import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Avatar from 'react-avatar';
import { useIntl } from 'react-intl';
import { Organization } from '../../models';

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    padding: theme.spacing(0, 4),
    marginRight: theme.spacing(1),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    textTransform: 'uppercase',
    fontSize: theme.spacing(1.5),
  },
  avatarContainer: {
    marginRight: theme.spacing(3),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: 0,
  },
  infoContainer: {
    width: 'auto',
  },
  infoItem: {
    marginRight: theme.spacing(10),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  gridItem: {
    padding: 0,
  },
  avatar: {
    borderRadius: '50%',
  },
}));

interface UserSummaryProps {
  organization: Organization;
  countActiveUsers: number;
  countPendingInvitations: number;
  countRemovedUsers: number;
}

const UserSummary = (props: UserSummaryProps) => {
  const { countActiveUsers, countPendingInvitations, countRemovedUsers, organization } = props;
  const classes = useStyles();
  const intl = useIntl();
  const listUserSummary = [
    {
      name: intl.formatMessage({ id: 'home.user_summary.active_users' }),
      count: countActiveUsers,
      color: '#00D63C', // should use in theme
    },
    {
      name: intl.formatMessage({ id: 'home.user_summary.pending_invitation' }),
      count: countPendingInvitations,
      color: '#FFE294', // should use in theme
    },
    {
      name: intl.formatMessage({ id: 'home.user_summary.removed_users' }),
      count: countRemovedUsers,
      color: '#808B9A', // should use in theme
    },
  ];
  return (
    <Paper className={classes.paper}>
      <Grid container alignItems="center">
        <Grid
          xs={1}
          item
          className={classes.avatarContainer}
          classes={{ item: classes.gridItem, root: classes.gridItem }}
        >
          {organization.logo?.length
            ? (
              <img
                width={52}
                height={52}
                src={`/${organization.logo}`}
                title={organization.name}
                alt={organization.name}
                className={classes.avatar}
              />
            ) : (
              <Avatar
                size="52"
                round
                name={organization.name}
                maxInitials={2}
              />
            )}
        </Grid>
        <Grid
          container
          className={classes.infoContainer}
        >
          {listUserSummary.map(item => (
            <div className={classes.infoItem} key={item.name}>
              <Typography variant="subtitle1" className={classes.title}>
                <span style={{ color: item.color }}>&#11044;&nbsp;</span>
                {item.name}
              </Typography>
              <Typography variant="h2" style={{ marginTop: '.25rem' }}>
                {intl.formatNumber(item.count)}
              </Typography>
            </div>
          ))}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default UserSummary;
